<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer008">
<p class="TOCtitle">Contents</p>
<p class="TOCitem"><a href="#/Prologue#_idTextAnchor000">Prologue</a></p>
<p class="TOCitem"><a href="#/One#_idTextAnchor001">Chapter One</a></p>
<p class="TOCitem"><span href="#/Two#_idTextAnchor002" title="Link target outside of Sample">Chapter Two</span></p>
<p class="TOCitem"><span href="#/Three#_idTextAnchor003" title="Link target outside of Sample">Chapter Three</span></p>
<p class="TOCitem"><span href="#/Four#_idTextAnchor004" title="Link target outside of Sample">Chapter Four</span></p>
<p class="TOCitem"><span href="#/Five#_idTextAnchor005" title="Link target outside of Sample">Chapter Five</span></p>
<p class="TOCitem"><span href="#/Six#_idTextAnchor006" title="Link target outside of Sample">Chapter Six</span></p>
<p class="TOCitem"><span href="#/Seven#_idTextAnchor007" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="TOCitem"><span href="#/Eight#_idTextAnchor008" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="TOCitem"><span href="#/Nine#_idTextAnchor009" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="TOCitem"><span href="#/Ten#_idTextAnchor010" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="TOCitem"><span href="#/Eleven#_idTextAnchor011" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="TOCitem"><span href="#/Epilogue#_idTextAnchor012" title="Link target outside of Sample">Epilogue</span></p>
<p class="TOCitem"><span href="#/Alaskan_Oil_Barons_steele_Mikkelson_Family_Tree" title="Link target outside of Sample">Alaskan Oil Barons - Steele Mikkelson Family Tree</span></p>
<p class="TOCitem"><span href="#/Excerpt_from_Love_in_Catalina_Cove_by_Brenda_Jackson" title="Link target outside of Sample">Excerpt from <em class="ITALIC">Love in Catalina Cove</em> by Brenda Jackson</span></p>
<p class="TOCitem"><span href="#/Excerpt_A_Texan_for_Christmas_by_Jules_Bennett#_idTextAnchor015" title="Link target outside of Sample">Excerpt from <em class="ITALIC">A Texan for Christmas</em> by Jules Bennett</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?da3f4456